import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Flexbox } from '../general/Layout';
import { CountLabel as CountLabelBase } from './GenericListFooter';

const Text = styled.div`
  flex: 1;
  min-width: 0;
  padding: 0 1rem 0 1.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: 1rem;
  font-weight: 700;
`

const CountLabel = styled(CountLabelBase)`
  padding: 0 1rem 1.5rem 1rem;
  text-decoration: underline;
`

interface Props {
  headline?: string;
  countLabel?: string;
}
export const GenericListDashboardHead: FC<Props> = ({ headline, countLabel }) => {
  return (
    <Flexbox>
      <Text>{ headline }</Text>
      {
        countLabel &&
        <NavLink to="/operations">
          <CountLabel>{ countLabel }</CountLabel>
        </NavLink>
      }
    </Flexbox>
  )
}
